import { CRM_WEB_PAGES_URLS } from '../../CRM_WEB_PAGES_URLS';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const intrepid_health_brampton: OrganizationSettings = {
  name: 'Intrepid Health',
  fromEmail: 'info@intrepidhealthgroup.com',
  replyToEmail: 'info@intrepidhealthgroup.com',
  ecommerceEnabled: false,
  stripeEnabled: false,
  emrEnabled: true,
  conversationServiceId: '',
  appointmentconsentSection: `
        <p style="text-align: center;color: #536476;">
          By booking you agree to our&nbsp;
          <a
            href="javascript:window.open('https://intrepid.health/clinic-policies', 'popup', 'width=600,height=600');"
          >
              Clinic Policies
          </a>
        </p>
      `,

  // navigation
  crmWebAppLayout: {
    title: 'Brampton',
    icon: 'https://uploads-ssl.webflow.com/630cf5c3fde88d3fa5008ecc/64e7b973bdcebab0ff0d4f49_icon-intrepid-health.svg?ssl=1',
    // logo:
    //   'https://intrepidhealthgroup.com/wp-content/uploads/2020/07/cropped-android-chrome-512x512-1.png',
    emrPatientLink:
      'https://intrepid.kai-oscar.com/oscar/demographic/demographiccontrol.jsp?displaymode=edit&dboperation=search_detail&demographic_no=',

    mainMenu: [
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette'
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fa-solid fa-sliders'
          }
        ]
      }
    ]
  }
};
